import React, { useState, createContext, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import './Dashboard.scss';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Outlet } from 'react-router-dom';
import DashboardHeader from '../../components/Dashboard/DashboardHeader';
import Sidebar from '../../components/Dashboard/Sidebar';
import Loading from '../../components/Loading';

const MyContext = createContext();

function Dashboard() {
    const { user } = useAuth(); // Pega o usuário do contexto
    const [isToggleSidebar, setIsToggleSidebar] = useState(false);
    const [themeMode, setThemeMode] = useState(true);
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isOpenNav, setIsOpenNav] = useState(false);

    useEffect(() => {
        if (themeMode) {
            document.body.classList.remove('dark');
            document.body.classList.add('light');
            localStorage.setItem('themeMode', 'light')
        } else {
            document.body.classList.remove('light');
            document.body.classList.add('dark');
            localStorage.setItem('themeMode', 'dark')
        }
    }, [themeMode])

    useEffect(() => {
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            setWindowWidth(currentWidth);

            // if (currentWidth < 992) {
            //     setIsToggleSidebar(true);
            // }
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        }
    }, [])

    const openNav = () => {
        setIsOpenNav(true);
    }

    const values = {
        isToggleSidebar,
        setIsToggleSidebar,
        themeMode,
        setThemeMode,
        windowWidth,
        openNav,
        isOpenNav,
        setIsOpenNav
    };

    if (!user) {
        return <Loading />
    }

    return (
        <>
            <MyContext.Provider value={values}>
                <DashboardHeader />
                <div className='main d-flex'>
                    <div
                        className={`sidebarOverlay ${isOpenNav ? 'show' : 'd-none'}`}
                        onClick={() => setIsOpenNav(false)}
                    />
                    <div className={`sidebarWrapper ${isToggleSidebar ? 'toggle' : ''} ${isOpenNav ? 'open' : ''}`} >
                        <Sidebar />
                    </div>

                    <div className={`content ${isToggleSidebar ? 'toggle' : ''}`}>
                        <div className='right-content w-100'>
                            <Outlet />
                        </div>
                    </div>
                </div>
            </MyContext.Provider>
        </>
    )
}

export default Dashboard;
export { MyContext };
